/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateProfileCategoryYearDto } from './CreateUpdateProfileCategoryYearDto';
import {
    CreateUpdateProfileCategoryYearDtoFromJSON,
    CreateUpdateProfileCategoryYearDtoFromJSONTyped,
    CreateUpdateProfileCategoryYearDtoToJSON,
} from './CreateUpdateProfileCategoryYearDto';

/**
 * 
 * @export
 * @interface CreateUpdateProfileCategoryDto
 */
export interface CreateUpdateProfileCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryDto
     */
    profileId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProfileCategoryDto
     */
    active: boolean;
    /**
     * 
     * @type {Array<CreateUpdateProfileCategoryYearDto>}
     * @memberof CreateUpdateProfileCategoryDto
     */
    profileCategoriesYears: Array<CreateUpdateProfileCategoryYearDto>;
}

/**
 * Check if a given object implements the CreateUpdateProfileCategoryDto interface.
 */
export function instanceOfCreateUpdateProfileCategoryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "profileId" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "profileCategoriesYears" in value;

    return isInstance;
}

export function CreateUpdateProfileCategoryDtoFromJSON(json: any): CreateUpdateProfileCategoryDto {
    return CreateUpdateProfileCategoryDtoFromJSONTyped(json, false);
}

export function CreateUpdateProfileCategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateProfileCategoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'profileId': json['profileId'],
        'active': json['active'],
        'profileCategoriesYears': ((json['profileCategoriesYears'] as Array<any>).map(CreateUpdateProfileCategoryYearDtoFromJSON)),
    };
}

export function CreateUpdateProfileCategoryDtoToJSON(value?: CreateUpdateProfileCategoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'profileId': value.profileId,
        'active': value.active,
        'profileCategoriesYears': ((value.profileCategoriesYears as Array<any>).map(CreateUpdateProfileCategoryYearDtoToJSON)),
    };
}

